<template>
  <div>
    <section class="section-hero sc-login">
      <div class="container">
        <div class="row">
          <div class="col-md-12 text-center">
            <LoadingState title="Loading..." subtitle="Please wait while we set things up for you!"></LoadingState>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import {functions} from '@/firebase'
import {httpsCallable} from "firebase/functions";
import LoadingState from "@/components/empty-states/LoadingState";

export default {
  components: {LoadingState},
  mounted() {
    const createSession = httpsCallable(functions, 'createCustomerPortalSession')

    createSession()
        .then(response => response.data)
        .then(data => data.url)
        .then(url => window.location.replace(url))
        .catch(err => console.error(err))
  }
}
</script>
